// @ts-nocheck
import DoubleCurrencyLogo from "components/DoubleLogo";
import Modal from "components/Modal";
import { RowBetween } from "components/Row";
import TransactionConfirmationModal, { ConfirmationModalContent } from "components/TransactionConfirmationModal";
import { utils } from "ethers";
import { useToken } from "hooks/Tokens";
import { useTotalSupply } from "hooks/useTotalSupply";
import { useV2Pair } from "hooks/useV2Pairs";
import { useCallback, useEffect, useState } from "react";
import { ArrowLeft } from "react-feather";
import ReactGA from "react-ga4";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";
import { MigrationDetails } from "types/position";
import { unwrappedToken } from "utils/unwrappedToken";

import { TransactionResponse } from "@ethersproject/providers";

import { useMigratorContract } from "../../hooks/useContract";
import { TransactionType } from "../../state/transactions/actions";
import { useTransactionAdder } from "../../state/transactions/hooks";
import { currencyId } from "../../utils/currencyId";

const HideBackground = styled.div`
  position:fixed;
  top:65px;
  right:0;
  left:0;
  bottom:0;
  background-color: black;
`

const RemoveLiquidityWarrap = styled.div`
  max-width: 512px;
  padding: 1px;
  background: linear-gradient(73.6deg, #85FFC4 2.11%, #5CC6FF 42.39%, #BC85FF 85.72%);
  border-radius: 40px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const RemoveLiquidity = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #000000;
  border-radius: 40px;
  padding-bottom: 30px;
`

const PrimaryPositionIdData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > * {
    margin-right: 8px;
  }
`

const DataText = styled.div`
  font-weight: 600;
  font-size: 18px;
  color:white;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
  `};
`

interface PositionListItemProps {
  setActiveKey:(value: any) => void;
  activeKey: any;
  positionDetails: MigrationDetails;
  index:number;
 }

export default function PairListItem({ setActiveKey, activeKey, positionDetails , index}: PositionListItemProps) {
  const {
    capital: token0Address,
    asset: token1Address,
    lpAmount: liquidityRaw,
    capitalImported: token0AmountRaw,
    assetImported: token1AmountRaw,
    capitalReceived: token0RAmountRaw,
    assetReceived: token1RAmountRaw,
    fee: feeAmountRaw,
    bundle: bundleID,
    id,
    status
  } = positionDetails;
  const history = useHistory()
  const [waiting, setWaiting] = useState(false);
  const [collapse, setCollapse] = useState(true);
  const [removeClicked, setRemoveClicked] = useState(false);
  const pool = window.localStorage.getItem('SELECT_POOL_MIGRATE') || 'Ubeswap';
  const migrateContract = useMigratorContract(pool.toLowerCase());

  useEffect(()=>{
	  if(id === activeKey){
		  setCollapse(false)
	  } else {
		  setCollapse(true)
	  }

  },[activeKey, id])


  const removeOnClick = () => {
    if (!removeClicked)
      setRemoveClicked(true);
    else setRemoveClicked(false);

  }
  const changeCollpase = () => {
    if (collapse){

		  setActiveKey(id);
    }
    else{

      setActiveKey("");
    }
  }

  const token0 = useToken(token0Address)
  const token1 = useToken(token1Address)

  const currency0 = token0 ? (token0?.tokenInfo ? token0?.tokenInfo : unwrappedToken(token0)) : undefined
  const currency1 = token1 ? (token1?.tokenInfo ? token1?.tokenInfo : unwrappedToken(token1)) : undefined
  const token0Amount = utils.formatUnits(token0AmountRaw, currency0?.decimals);
  const token1Amount = utils.formatUnits(token1AmountRaw, currency1?.decimals);

  const token0RAmount = utils.formatUnits(token0RAmountRaw, currency0?.decimals);
  const token1RAmount = utils.formatUnits(token1RAmountRaw, currency1?.decimals);
  const feeAmount = utils.formatUnits(feeAmountRaw, currency0?.decimals);

  const [, pair] = useV2Pair(currency0 ?? undefined, currency1 ?? undefined, 'SELECT_POOL_MIGRATE')
  const liquidity = utils.formatUnits(liquidityRaw, pair?.liquidityToken.decimals);
  const totalSupply = useTotalSupply(pair?.liquidityToken);
  const pairToken0Amount = pair?.token0.address === token0?.address ? pair?.tokenAmounts[0].quotient : pair?.tokenAmounts[1].quotient;
  const pairToken1Amount = pair?.token0.address === token0?.address ? pair?.tokenAmounts[1].quotient : pair?.tokenAmounts[0].quotient;
  const currentToken0AmountRaw =  pairToken0Amount * (liquidityRaw / totalSupply?.quotient);
  const currentToken1AmountRaw =  pairToken1Amount * (liquidityRaw / totalSupply?.quotient);
  const currentToken0Amount = utils.formatUnits(currentToken0AmountRaw ? currentToken0AmountRaw.toLocaleString('fullwide', {useGrouping:false}).split(".")[0] : 0, currency0?.decimals);
  const currentToken1Amount = utils.formatUnits(currentToken1AmountRaw ? currentToken1AmountRaw.toLocaleString('fullwide', {useGrouping:false}).split(".")[0] : 0, currency1?.decimals);
  const ROI =  (((Math.sqrt(currentToken0Amount * currentToken1Amount) - Math.sqrt(token0Amount * token1Amount)) / (Math.sqrt(token0Amount * token1Amount))) * 100).toFixed(2);
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false) // clicked confirm
  const [txHash, setTxHash] = useState<string>('')
  const addTransaction = useTransactionAdder()
  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    setRemoveClicked(false)
    if (txHash) {
      history.push('/migrate/v2');
    }
    // if there was a tx hash, we want to clear the input
    setTxHash('')
  }, [txHash, history])

  const confimrOnClick = async () => {
    if (migrateContract) {
      setWaiting(true);
      try {
        await migrateContract.migrateLPTokens(token0Address, token1Address, bundleID).then((response: TransactionResponse) => {
          setAttemptingTxn(false)
          addTransaction(response, {
            type: TransactionType.REMOVE_LIQUIDITY_V3,
            baseCurrencyId: currencyId(currency0),
            quoteCurrencyId: currencyId(currency1),
            expectedAmountBaseRaw: currentToken0AmountRaw ? currentToken0AmountRaw.toString() : "0",
            expectedAmountQuoteRaw: currentToken1AmountRaw ? currentToken1AmountRaw.toString() : "0",
          })
          setWaiting(false);
          setTxHash(response.hash)
          setShowConfirm(true);
          ReactGA.event({
            category: 'Liquidity',
            action: 'Migrate',
            label: [currency0?.symbol, currency1?.symbol].join('/'),
          })
        })

      }
      catch (error) {
        console.error('Failed to send transaction', error)
        setAttemptingTxn(false)
        // we only care if the error is something _other_ than the user rejected the tx
        if (error?.code !== 4001) {
          console.error(error)
        }
      }
      setWaiting(false);

    }
  }
  const StyledArrowLeft = styled(ArrowLeft)`
    color:white;
  `
  return (
    <>
     <Modal isOpen={removeClicked}  minHeight={false} maxHeight={100}>
       <HideBackground>
          <RemoveLiquidityWarrap>
            <RemoveLiquidity>
              <RowBetween style={{    padding: "32px 28px 0px"}}>
                <button onClick = {removeOnClick} style={{ width: "0", height: "100%",background:'transparent', border: "0px" }} >
                  <StyledArrowLeft  />
                </button>
                <div className="remove-header-top" style={{ display: "flex", margin:'auto', justifyContent: "center" }}>
                    <p style={{margin:" 0px", fontSize:'24px'}} >Migrate Liquidity</p>
                </div>
              </RowBetween>

            <div className="single-liquidity-content" style={{ marginTop:'32px',overflow: 'hidden', padding:'0px 32px',width:'100%' }}>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Capital in the Pool</p>
                <p className="single-token-right " style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+currentToken0Amount).toFixed(6)}</span>
                  <span className="value-unit">  {currency0?.symbol}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Token in the Pool</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+currentToken1Amount).toFixed(6)}</span>
                  <span className="value-unit">   {currency1?.symbol}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Capital imported</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+token0Amount).toFixed(6)}</span>
                  <span className="value-unit">    {currency0?.symbol}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Token imported</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+token1Amount).toFixed(6)}</span>
                  <span className="value-unit">    {currency1?.symbol}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Return</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num"> { ROI }%</span>
                  <span className="value-unit">   {'ROI'}</span>
                </p>
              </div>

              <div style={!waiting?{ marginTop:'50px', justifyContent: "center", transition: "1s" }:{marginTop:'50px', border:'0px',cursor: 'not-allowed',opacity:'0.45'}}>
                <button onClick={() => confimrOnClick()}><p>{waiting?'Transaction in progress-Please wait':'Migrate'}</p></button>
              </div>
            </div>
            </RemoveLiquidity>
          </RemoveLiquidityWarrap>
       </HideBackground>

     </Modal>
      <TransactionConfirmationModal
          isOpen={showConfirm}
          onDismiss={handleDismissConfirmation}
          attemptingTxn={attemptingTxn}
          hash={txHash}
          content={() => (
            <ConfirmationModalContent
              title={""}
              onDismiss={handleDismissConfirmation}
              bottomContent={() => (
                <button className='view-etherscan'>
                  <p>
                    View on Etherscan
                  </p>
                </button>
              )}
            />
          )}
        />
      <RowBetween>
        <>{!removeClicked ?
        <>
         <div className="single-liquidity" style={index%2 === 0 ?{backgroundColor:'#2F2A3C'}:{backgroundColor:'#201D29'}}>
            <div onClick={changeCollpase} style={{ cursor: "pointer" }}>
              <div className="single-liquidity-header">
                <div className="single-liquidity-header-left">
                <PrimaryPositionIdData>
                  {
                    currency0 && currency1 &&
                      <>
                        <div style={{display: 'contents'}}>
                          <DoubleCurrencyLogo currency0={currency0} currency1={currency1} size={36} margin />
                        </div>
                        <DataText>
                          &nbsp;{currency0?.symbol}&nbsp;{(currency0 && currency1) ? "/" : ""}&nbsp;{currency1?.symbol}&nbsp;&nbsp;
                          (#{bundleID})&nbsp;&nbsp;
                          {status === "Inactive" ? "(Closed)": ""}
                        </DataText>
                        &nbsp;
                      </>
                  }
                </PrimaryPositionIdData>
                </div>
                <div className="single-liquidity-header-right">
                  <img src="./images/up2.png" alt="up" style={{ width: "20px", height: "20px", display: collapse ? "none" : "block" }} />
                  <img src="./images/down2.png" alt="down" style={{ width: "20px", height: "20px", display: collapse ? "block" : "none" }} />
                </div>
              </div>
            </div>
            <div className="single-liquidity-content" style={{ height: collapse ? "0px" :status === "Inactive" ? "250px": "300px", overflow: 'hidden' }}>
               <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Pair imported</p>
                <p className="single-token-right " style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{liquidity < 0.01 ? (+liquidity).toFixed(6) : (+liquidity).toFixed(6)}</span>
                  <span className="value-unit">   {"LP"}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Capital imported</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+token0Amount).toFixed(6)}</span>
                  <span className="value-unit">   {currency0?.symbol}</span>
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Token imported</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+token1Amount).toFixed(6)}</span>
                  <span className="value-unit">   {currency1?.symbol}</span>
                </p>
              </div>
              {status === "Inactive" ?<>
              <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                <p className="single-token-left">Protocol fee deducted</p>
                <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                  <span className="value-num">{(+feeAmount).toFixed(6)}</span>
                  <span className="value-unit">   {currency0?.symbol}</span>
                </p>
              </div>
                <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                  <p className="single-token-left">Captal received</p>
                  <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                    <span className="value-num">{(+token0RAmount).toFixed(6)}</span>
                    <span className="value-unit">    {currency0?.symbol}</span>
                  </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                  <p className="single-token-left">Token deposited</p>
                  <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                    <span className="value-num">{(+token1RAmount).toFixed(6)}</span>
                    <span className="value-unit">   {currency1?.symbol}</span>
                  </p>
                </div>
              </>:<>
                <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                  <p className="single-token-left">Pool share</p>
                  <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                    <span className="value-num">{ (liquidityRaw / totalSupply?.quotient * 100).toFixed(4)} %</span>
                    <span className="value-unit">   {'Pool'}</span>
                  </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                  <p className="single-token-left">Pool capital amount</p>
                  <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                    <span className="value-num">{(+currentToken0Amount).toFixed(6)}</span>
                    <span className="value-unit">    {currency0?.symbol}</span>
                  </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", minInlineSize: "max-content" }}>
                  <p className="single-token-left">Pool token amount</p>
                  <p className="single-token-right" style={{ display:"flex", justifyContent: "space-between" }}>
                    <span className="value-num">{(+currentToken1Amount).toFixed(6)}</span>
                    <span className="value-unit">   {currency1?.symbol}</span>
                  </p>
                </div></>}

              {status === "Inactive" ? <></>
              :
                <div style={{ display: "flex", justifyContent: "center", transition: "1s", marginTop: 16 }}>
                  <button onClick={() => removeOnClick()}>
                    <p style={{fontSize:'16px', fontWeight:'600'}}>
                      Migrate Liquidity
                    </p>
                  </button>
                </div>
              }

            </div>
          </div>
        </>
          :
          <div >

          </div>
        }
        </>
      </RowBetween>
    </>
  )
}
